import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from 'Context';
import { Pathname } from 'Routes';

// ── Release toggles for the new Affiliate / Membership module ───────────────
// MEMBERSHIP_RELEASED — the master switch for the full release. When true, EVERY
// account gets the new Affiliate/Membership flow (the AFFILIATE_EMAILS allow-list
// is bypassed). Flip to false to restrict it to the allow-list again.
export const MEMBERSHIP_RELEASED = true;

// MEMBERSHIP_PROMO_ENABLED — when false, the promo-code entry is hidden across
// the membership module (enrolment checkout + create-user payment popup). Flip
// to true to bring promo codes back.
export const MEMBERSHIP_PROMO_ENABLED = false;

// Hardcoded allow-list of accounts that get the Affiliate Program (and NOT User
// Management) while MEMBERSHIP_RELEASED is false. Keep lowercase.
export const AFFILIATE_EMAILS = [
  // 'layne@projector.app',
  // 'becky@beacondigitalvideo.com',
  // 'rob@robmarks.com',
  // 'egranot@gmail.com',
  'newaccountfortest@yopmail.com',
  'newtestaff1@yopmail.com',
  'newaccounttwss@yopmail.com',
  'testaccocuntaff1@yopmail.com',
  'testaccocuntaff3@yopmail.com',
  'testaccocuntaff2@yopmail.com',
  'testaccocuntaff4@yopmail.com',
  'testaccocuntaff5@yopmail.com',
  'testaccocuntaff6@yopmail.com',
  'testaccocuntaff7@yopmail.com',
  'testaccocuntaff9@yopmail.com',
  'testaccocuntaff10@yopmail.com',
  'chip12@yopmail.com',
  'testbugs@yopmail.com',
  'johny11@yopmail.com',
  'becky@beacondigitalvideo.com',
  'robmarks@me.com',
  'egranot@gmail.com',
  'layne@projector.app',
];

export const isAffiliateUser = (email) => {
  // Full release → everyone gets the membership flow.
  if (MEMBERSHIP_RELEASED) return true;
  return !!email && AFFILIATE_EMAILS.includes(String(email).trim().toLowerCase());
};

// ── Route guards — block access via a direct URL. Render nothing until we know
// who the user is (avoids a wrong-page flash / redirect bounce during boot).
export const AffiliateOnly = ({ children }) => {
  const { userDetails } = useContext(AppContext);
  const email = userDetails?.email;
  if (!email) return null;
  return isAffiliateUser(email)
    ? children
    : <Navigate to={Pathname.getSettingsPath(Pathname.settings.manageUsers)} replace />;
};

export const ManageUsersOnly = ({ children }) => {
  const { userDetails } = useContext(AppContext);
  const email = userDetails?.email;
  if (!email) return null;
  return isAffiliateUser(email)
    ? <Navigate to={Pathname.getSettingsPath(Pathname.settings.affiliate)} replace />
    : children;
};
